import { render } from "./OverviewSummary.vue?vue&type=template&id=9bdcbff8&scoped=true"
import script from "./OverviewSummary.vue?vue&type=script&lang=js"
export * from "./OverviewSummary.vue?vue&type=script&lang=js"

import "./OverviewSummary.vue?vue&type=style&index=0&id=9bdcbff8&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bdcbff8"]])

export default __exports__